var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('dynameat-breadcrumbs',{attrs:{"items":_vm.currentBreadcrumbs},on:{"menu":_vm.onMenuBack,"restaurant":_vm.onRestaurantBack,"section":_vm.onSectionBack,"clause":_vm.onClauseBack}}),_c('section-product-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }